const icon_list = [
    {icon:'waves',descr:'content', type: 'C', id: 1},
    {icon:'crop_7_5',descr:'short answer', type: 'T', id: 2},
    {icon:'list',descr:'selection', type: 'T', id: 3},
    {icon:'grain',descr:'multiselection', type: 'T', id: 4},
    {icon:'edit',descr:'insert code', type: 'T', id: 5},
    {icon:'sort',descr:'drag-drop code', type: 'T', id: 6},
    {icon:'autorenew',descr:'reorder', type: 'T', id: 7},
    {icon:'play_circle_outline',descr:'test case program', type: 'P', id: 8},
    {icon:'playlist_play',descr:'xUnit program', type: 'P', id: 9},
    {icon:'cloud_upload',descr:'SQL', type: 'P', id: 10},
    {icon:'code',descr:'HTML', type: 'H', id: 11},
    {icon:'widgets',descr:'extended content', type: 'C', id: 12},
    {icon:'short_text',descr:'extended short answer', type: 'T', id: 13},
    {icon:'blur_circular',descr:'extended short selection', type: 'T', id: 14},
    {icon:'blur_linear',descr:'extended short multiselection', type: 'T', id: 15},
    {icon:'receipt',descr:'extended essay', type: 'E', id: 16},
    {icon:'chat',descr:'extended GenAI', type: 'G', id: 17},
  ]

export function getTaskIcon(index) {
    return icon_list[index-1].icon
}

export function getIcons() {
    return icon_list
}